import React, { useEffect } from "react";
import {
  Box,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Typography,
  TextField,
} from "@mui/material";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import Editor from "ckeditor5-custom-build/build/ckeditor";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useSnackbar } from "notistack";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function Level6(props) {
  const { enqueueSnackbar } = useSnackbar();
  const { isSmall } = useBreakpoints();

  const [level6, setLevel6] = React.useState({
    description: "",
    usageWay: "",
    sumDescription: "",
    metaDescription: "",
  });

  useEffect(() => {
    if (props.fireGetData) {
      props.getDataFromLevel6(level6);
    }
  }, [props.fireGetData]);

  return (
    <Accordion
      expanded={props.expanded === "panel6"}
      style={{ margin: "20px", paddingBottom: "15px" }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <Typography>مرحله ششم</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <Typography color="secondary" sx={{ mb: 1, fontWeight: "bold" }}>
              توضیحات :
            </Typography>
            <CKEditor
              config={{
                language: "fa",
                link: {
                  decorators: {
                    addTargetToExternalLinks: {
                      mode: "automatic",
                      callback: (url) => /^(https?:)?\/\//.test(url),
                      attributes: {
                        target: "_blank",
                        rel: "noopener noreferrer",
                      },
                    },
                  },
                },
              }}
              editor={Editor}
              data={level6.description}
              onChange={(event, editor) => {
                const data = editor.getData();
                setLevel6({ ...level6, description: data });
              }}
              onReady={(editor) => {
                editor.editing.view.change((writer) => {
                  writer.setStyle(
                    "height",
                    "250px",
                    editor.editing.view.document.getRoot()
                  );
                });
              }}
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <Typography color="secondary" sx={{ mb: 1, fontWeight: "bold" }}>
              روش مصرف :
            </Typography>
            <CKEditor
              config={{
                language: "fa",
                link: {
                  decorators: {
                    addTargetToExternalLinks: {
                      mode: "automatic",
                      callback: (url) => /^(https?:)?\/\//.test(url),
                      attributes: {
                        target: "_blank",
                        rel: "noopener noreferrer",
                      },
                    },
                  },
                },
              }}
              editor={Editor}
              data={level6.usageWay}
              onChange={(event, editor) => {
                const data = editor.getData();
                setLevel6({ ...level6, usageWay: data });
              }}
              onReady={(editor) => {
                editor.editing.view.change((writer) => {
                  writer.setStyle(
                    "height",
                    "250px",
                    editor.editing.view.document.getRoot()
                  );
                });
              }}
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <Typography color="secondary" sx={{ mb: 1, fontWeight: "bold" }}>
              توضیحات متا:
            </Typography>
            <TextField
              fullWidth
              value={level6.metaDescription}
              multiline
              rows={10.9}
              onChange={(evt) => {
                if (evt.target.value.length < 151) {
                  setLevel6({ ...level6, metaDescription: evt.target.value });
                  return;
                } else {
                  setLevel6({
                    ...level6,
                    metaDescription: level6.metaDescription,
                  });
                  enqueueSnackbar("بیشتر از مقدار مجاز (150 کاراکتر)", {
                    variant: "error",
                    autoHideDuration: 2000,
                    preventDuplicate: true,
                  });
                  return;
                }
              }}
              size="small"
              variant="outlined"
            />
          </Box>
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <Typography color="secondary" sx={{ mb: 1, fontWeight: "bold" }}>
              توضیحات اختصاری:
            </Typography>
            <CKEditor
              config={{
                language: "fa",
                link: {
                  decorators: {
                    addTargetToExternalLinks: {
                      mode: "automatic",
                      callback: (url) => /^(https?:)?\/\//.test(url),
                      attributes: {
                        target: "_blank",
                        rel: "noopener noreferrer",
                      },
                    },
                  },
                },
              }}
              editor={Editor}
              data={level6.sumDescription}
              onChange={(event, editor) => {
                const data = editor.getData();
                setLevel6({ ...level6, sumDescription: data });
              }}
              onReady={(editor) => {
                editor.editing.view.change((writer) => {
                  writer.setStyle(
                    "height",
                    "250px",
                    editor.editing.view.document.getRoot()
                  );
                });
              }}
            />
          </Box>
          <Box
            gridColumn="span 12"
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                props.setExpanded("panel5");
              }}
            >
              مرحله قبل
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                enqueueSnackbar("مرحله ششم با موفقیت تکمیل شد", {
                  variant: "success",
                  autoHideDuration: 2000,
                });
                props.setExpanded("panel7");
              }}
            >
              مرحله بعد
            </Button>
          </Box>
        </Box>
      </AccordionDetails>
    </Accordion>
  );
}
